module.exports = "/assets/e2182991802bf5bbeb242c4efad3c671.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CZ.png
// module id = 2411
// module chunks = 0